import Promise from 'bluebird';
import 'underscore';

function OfflineSearch() {}

// Not implemented, empty promise
OfflineSearch.prototype.byWord = Promise.resolve();

export default OfflineSearch;
